/**
 * 2026-10-07 presence-states follow-up — pure derivation of the dashboard
 * stat-card counts from the /dashboard response. onlineDevices itself is
 * UNCHANGED in name and meaning (it already includes standby/app_closed,
 * since both require a fresh last_login to even be reachable) — the
 * truly-online-only count for the "Online Devices" card is derived here,
 * never read directly off a backend field.
 */
export function deriveDeviceCounts(stats) {
  const total = stats?.devices ?? 0;
  const standby = stats?.standbyDevices ?? 0;
  const appClosed = stats?.appClosedDevices ?? 0;
  const offline = stats?.offlineDevices ?? 0;
  const onlineOnly = (stats?.onlineDevices ?? 0) - standby - appClosed;
  const notShowingNow = standby + appClosed;

  return { total, onlineOnly, standby, appClosed, offline, notShowingNow };
}
